/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import { Box, Typography } from "@mui/material";
import { Formik } from "formik";
import * as Sentry from "@sentry/react";
import React, { useState } from "react";
// import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Appointment from "../../../services/api/appointment";
import { debounce } from "../../../utils/helper";
import GohonzonOtherInput from "../../GohonzonOtherInput/GohonzonOtherInput";
import Button from "../../common/Button";
import { CommonStyles } from "../../common/Button/commonButtonStyle";
import Modal from "../../common/Modal/Modal";
import InputField from "../../common/new/InputField/InputField";
import styles from "./style";
import { AlertStatus } from "../../../contants";
import { selectUserProfile } from "../../../redux/selectors/user";

export const APPOINTMENT_RADIO = {
  DID_COMMITTEE_MEET: "didCommitteeMeet",
  DID_YOU_PARTICIPATE: "didYouParticipate",
  DO_YOU_APPROVE_APPOINTMENT: "doYouApproveAppointment",
  REMARK: "doYouApproveAppointmentRemark",
};

const prepareBody = (formValues) => {
  return Object.keys(formValues).reduce((acc, key) => {
    return Object.assign(acc, { [key]: formValues[key] === "YES" });
  }, {});
};

const remarksValidation = (remark, values) => {
  if (!values[APPOINTMENT_RADIO.DID_COMMITTEE_MEET]) {
    return "Please select Did the committee Meet option";
  }

  if (!values[APPOINTMENT_RADIO.DID_YOU_PARTICIPATE]) {
    return "Please select Did you participate option";
  }

  if (!values[APPOINTMENT_RADIO.DO_YOU_APPROVE_APPOINTMENT]) {
    return "Please select Do you approve the Appointment option";
  }
  if (!remark && values.doYouApproveAppointmentRemark) {
    return "";
  }

  if (!remark || !values.doYouApproveAppointmentRemark) {
    return "Please enter remark";
  }

  return "";
};

function Alert({ open, onClose, onSubmit, isLoading }) {
  // const messages = {
  //   verification: "recommendation application",
  //   recommended: "review for approval (L1) application",
  //   recommended2: "review for approval (L2) application",
  // };
  return (
    <Box>
      <Modal open={open} onClose={onClose}>
        <Typography
          style={{ fontSize: "20px", fontWeight: "500", paddingBottom: "20px" }}
        >
          Are you sure you want to
          <br />
          submit this proposal ?{/* {messages[type]} ? */}
        </Typography>
        <Box style={{ paddingTop: "50px", justifyContent: "space-between" }}>
          <Button
            onClick={onSubmit}
            label="Yes"
            style={{ marginRight: "10px" }}
            disabled={isLoading}
          />
          <Button onClick={onClose} label="No" variant="outlined" />
        </Box>
      </Modal>
    </Box>
  );
}

function CommitteeParticipate({ open, onClose, application, onBack, toast }) {
  const [remark, setRemark] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const { type } = useParams();
  console.log("application", application);

  const toggleAlert = () => {
    setOpenAlert(false);
  };

  const acceptAppointmentHandler = () => {
    setOpenAlert(true);
  };

  const submitReviewRequest = async (values) => {
    setIsLoading(true);
    try {
      const body = prepareBody(values);
      const error = remarksValidation(remark, values);
      if (error) throw new Error(error);

      setOpenAlert(true);

      await Appointment.reviewAppointment(
        {
          ...body,
          doYouApproveAppointmentRemark:
            remark || values.doYouApproveAppointmentRemark,
        },
        application.memberDetails.memberId,
        application.id
      );
      toast.show("Reviewed Successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        onClose();
        onBack();
      }, 2000);
    } catch (error) {
      setIsLoading(false);
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    } finally {
      setIsLoading(false);
    }
  };

  const user = useSelector(selectUserProfile);
  const loggedInUserId = user.memberId;

  const loggedInVoter = application?.voters?.filter(
    (item) => item?.voterMember?.memberId === loggedInUserId
  );

  return (
    <Modal open={open} onClose={onClose}>
      <div>
        <Formik
          initialValues={{
            [APPOINTMENT_RADIO.DID_COMMITTEE_MEET]:
              // loggedInVoter[0]?.didCommitteeMeet === true
              //   ? "YES"
              //   : loggedInVoter[0]?.didCommitteeMeet === null
              //   ? ""
              //   : "NO",
              loggedInVoter && loggedInVoter.length > 0
                ? loggedInVoter[0]?.didCommitteeMeet === true
                  ? "YES"
                  : loggedInVoter[0]?.didCommitteeMeet === null
                  ? ""
                  : "NO"
                : "",
            [APPOINTMENT_RADIO.DID_YOU_PARTICIPATE]:
              // loggedInVoter[0]?.didYouParticipate === true
              //   ? "YES"
              //   : loggedInVoter[0]?.didYouParticipate === null
              //   ? ""
              //   : "NO",
              loggedInVoter && loggedInVoter.length > 0
                ? loggedInVoter[0]?.didYouParticipate === true
                  ? "YES"
                  : loggedInVoter[0]?.didYouParticipate === null
                  ? ""
                  : "NO"
                : "",
            [APPOINTMENT_RADIO.DO_YOU_APPROVE_APPOINTMENT]:
              // loggedInVoter[0]?.doYouApproveAppointment === true
              //   ? "YES"
              //   : loggedInVoter[0]?.doYouApproveAppointment === null
              //   ? ""
              //   : "NO",
              loggedInVoter && loggedInVoter.length > 0
                ? loggedInVoter[0]?.doYouApproveAppointment === true
                  ? "YES"
                  : loggedInVoter[0]?.doYouApproveAppointment === null
                  ? ""
                  : "NO"
                : "",
            doYouApproveAppointmentRemark:
              // loggedInVoter[0]?.doYouApproveAppointmentRemark || "",
              loggedInVoter && loggedInVoter.length > 0
                ? loggedInVoter[0]?.doYouApproveAppointmentRemark || ""
                : "",
          }}
          enableReinitialize
          // onSubmit={debounce(submitReviewRequest)}
        >
          {({ handleChange, values, handleSubmit, errors }) => (
            <form onSubmit={handleSubmit}>
              <Box>
                <Typography
                  style={{
                    color: "#8C8C8C",
                    fontSize: "20px ",
                    fontWeight: "500",
                  }}
                >
                  Appointment Application Proposal
                </Typography>
                <Box marginTop="30px" color="#183053">
                  <Typography />
                </Box>
                <div>
                  <GohonzonOtherInput
                    name={APPOINTMENT_RADIO.DID_COMMITTEE_MEET}
                    value={values[APPOINTMENT_RADIO.DID_COMMITTEE_MEET]}
                    preLabel="Did the committee Meet ?"
                    handleChange={handleChange}
                    required
                    error={errors[APPOINTMENT_RADIO.DID_COMMITTEE_MEET]}
                  />
                  <GohonzonOtherInput
                    name={APPOINTMENT_RADIO.DID_YOU_PARTICIPATE}
                    value={values[APPOINTMENT_RADIO.DID_YOU_PARTICIPATE]}
                    preLabel="Did you participate ?"
                    handleChange={handleChange}
                    required
                    error={errors[APPOINTMENT_RADIO.DID_YOU_PARTICIPATE]}
                  />
                  <GohonzonOtherInput
                    name={APPOINTMENT_RADIO.DO_YOU_APPROVE_APPOINTMENT}
                    value={values[APPOINTMENT_RADIO.DO_YOU_APPROVE_APPOINTMENT]}
                    preLabel="Do you approve the Appointment ?"
                    handleChange={handleChange}
                    required
                    error={errors[APPOINTMENT_RADIO.DO_YOU_APPROVE_APPOINTMENT]}
                  />
                </div>
                <Box mt={7}>
                  <InputField
                    type="text"
                    defaultValue=""
                    name="doYouApproveAppointmentRemark"
                    label="Enter your remark here..."
                    value={remark || values?.doYouApproveAppointmentRemark}
                    onChange={(e) => {
                      setRemark(e.target.value);
                      handleChange(e);
                    }}
                    // onChange={handleChange}
                    InputProps={{ sx: { minHeight: "91px" } }}
                    required
                    style={styles.inputStyle}
                  />
                </Box>
                <div style={{ display: "flex", gap: 5 }}>
                  <Button
                    variant="contained"
                    style={CommonStyles.buttonStyle}
                    type="submit"
                    label="Submit"
                    // onClick={handleSubmit}
                    onClick={() => acceptAppointmentHandler()}
                  />
                  <Button
                    variant="outlined"
                    style={{
                      ...CommonStyles.buttonStyle,
                      marginLeft: "20px",
                    }}
                    onClick={onClose}
                    label="CANCEL"
                  />
                </div>
              </Box>
              <Alert
                open={openAlert}
                onClose={toggleAlert}
                onSubmit={() => {
                  setOpenAlert(false);
                  debounce(submitReviewRequest(values));
                }}
                isLoading={isLoading}
                // type={type}
              />
            </form>
          )}
        </Formik>
      </div>
    </Modal>
  );
}

export default CommitteeParticipate;
